import type { Interpolation, Theme } from "@emotion/react";
import { calcRemFromPx } from "../../util";
import { colorValues } from "../designTokens/colors/values/colorValues";
import { fontTokens } from "../designTokens/fonts/fontTokens";

/**
 * Resets some of the browser's default styling
 */
export const cssBaseline = (theme: "dark" | "light"): Interpolation<Theme> => {
  const backgroundColor = theme === "dark"
    ? colorValues.$black
    : colorValues.$beige100;

  return {
    "@layer base": {
      html: {
        boxSizing: "border-box",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      },
      "*, *::before, *::after": {
        boxSizing: "inherit",
      },
      "strong, b": {
        fontWeight: 600,
      },
      body: {
        color: "rgba(0, 0, 0, 0.87)",
        margin: 0,
        fontSize: `${calcRemFromPx(15)}rem`,
        fontFamily: fontTokens["$base-font"],
        fontWeight: 400,
        lineHeight: `${calcRemFromPx(21)}rem`,
        backgroundColor: backgroundColor,
      },
      "@media print": {
        body: {
          backgroundColor: colorValues.$white,
        },
      },
      "body::backdrop": {
        backgroundColor: backgroundColor,
      },
      /**
       * @see {@link https://github.com/mozilla/pdf.js/blob/8791b2474227774cf951e2880daccbf2ba25a77e/web/pdf_viewer.css#L57-L64}
       */
      ".hiddenCanvasElement": {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        display: "none",
      },
    },
  };
};
